module.exports = __webpack_public_path__ + "static/img/dashboard-white.7305152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/dashboard-white.svg
// module id = 615
// module chunks = 2